// Match {{ $var['key']['nested'] }} as defined in issue #8578 spec.
// Whitespace expressions and |filter pipelines are not supported.
const TEMPLATE_RE = /\{\{\s*\$(\w+)((?:\['[\w]+'\])*)\s*\}\}/g;
const KEY_RE = /\['([\w]+)'\]/g;

function lookup(context, varName, keyChain) {
  let value = context[varName];
  if (value === undefined || value === null) return '';

  let match;
  const re = new RegExp(KEY_RE.source, 'g');
  while ((match = re.exec(keyChain)) !== null) {
    if (value === undefined || value === null) return '';
    value = value[match[1]];
  }
  return value === undefined || value === null ? '' : String(value);
}

export function renderTitleTemplate(template, context) {
  if (typeof template !== 'string' || template === '') return '';
  return template.replace(TEMPLATE_RE, (_, varName, keyChain) =>
    lookup(context, varName, keyChain)
  );
}

// section: 'chatroom_list' (list view) | 'chatroom' (detail view)
// Returns '' when config is missing, template is missing, or render produces empty.
// Caller decides the fallback behaviour.
export function resolveChatroomTitle(chatroom, asStaff, moduleConfig, section) {
  if (!chatroom || !moduleConfig) return '';

  const senderTypeKey = asStaff ? 'sender_type_staff' : 'sender_type_customer';
  const sectionConfig = moduleConfig[senderTypeKey] && moduleConfig[senderTypeKey][section];
  const template = sectionConfig && sectionConfig.title;
  if (!template) return '';

  const customer = (chatroom.customers && chatroom.customers[0]) || null;
  const staff = (chatroom.staffs && chatroom.staffs[0]) || null;

  const context = {
    customer: customer || {},
    staff: staff || {},
  };

  return renderTitleTemplate(template, context);
}
